export class OffersOffcanvas 
{
    constructor(options = {}) 
    {
        this.options = {
            desktopMediaQuery: '(min-width: 768px)',
            ...options,
        };

        this.offcanvas = null;
        this.rootNode = null;

        this.handleOffcanvasClose = this.handleOffcanvasClose.bind(this);
        BX.Event.EventEmitter.subscribe('Mario.OffCanvas:close', this.handleOffcanvasClose);
    }

    show() 
    {
        if (this.offcanvas) {
            return;
        }

        this.rootNode = this.createOffcanvas();
        BX.Dom.append(this.rootNode, document.body);

        this.lockScroll();

        this.offcanvas = new OffCanvas(this.rootNode);
        this.offcanvas.toggle();

        this.renderLoading();
    }

    hide() 
    {
        if (this.offcanvas) {
            this.offcanvas.toggle();
        }
    }

    renderLoading() 
    {
        const content = this.getContentNode();
        if (!content) return;

        content.innerHTML = `
            <div class="offcanvas__loader">
                <span class="preloader preloader--inline"></span>
            </div>
        `;
    }

    render(offers)
    {
        const content = this.getContentNode();
        if (!content) {
            return;
        }

        const sortedOffers = [...offers].sort((a, b) =>
            String(a.size).localeCompare(String(b.size), undefined, { numeric: true, sensitivity: 'base' })
        );

        const wrapper = BX.Tag.render`
            <div class="product__basket-props js-add_to_basket_section_offers">
                ${sortedOffers.map(offer => BX.Tag.render`
                    <span class="product__basket-size btn-progress-small btn-progress-black js-ab-add_to_basket-item"
                        data-product="${offer.id}"
                        data-name="${offer.size}"
                        data-quantity="${offer.quantity}">${offer.size}</span>
                `)}
            </div>
        `;

        wrapper.querySelectorAll('.js-ab-add_to_basket-item').forEach(span => {
            span.addEventListener('click', () => this.hide());
        });

        content.innerHTML = '';
        BX.Dom.append(wrapper, content);
    }

    renderError(message) 
    {
        const content = this.getContentNode();
        if (!content) {
            return;
        }

        content.innerHTML = `<div class="offcanvas__error">${message}</div>`;
    }

    getContentNode() 
    {
        return this.rootNode
            ? this.rootNode.querySelector('[data-entity="offcanvas-content"]')
            : null;
    }

    handleOffcanvasClose({ data: { offcanvas } }) 
    {
        if (offcanvas !== this.offcanvas) {
            return;
        }

        offcanvas.destroy();
        BX.Dom.remove(offcanvas.rootNode);

        this.offcanvas = null;
        this.rootNode = null;

        if (!window._store?.state?.basket?.offcanvas) {
            this.unlockScroll();
        }

        BX.Event.EventEmitter.unsubscribe('Mario.OffCanvas:close', this.handleOffcanvasClose);
    }

    lockScroll() 
    {
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.paddingRight = `${scrollbarWidth}px`;
        document.body.style.overflow = 'hidden';
    }

    unlockScroll() 
    {
        document.body.style.paddingRight = '';
        document.body.style.overflow = '';
    }

    isDesktop() 
    {
        return window.matchMedia(this.options.desktopMediaQuery).matches;
    }

    createOffcanvas() 
    {
        const position = this.isDesktop() ? 'center' : 'bottom';

        return BX.Tag.render`
            <div class="offcanvas offcanvas--quick-cart" data-entity="offcanvas-quick-cart" data-position="${position}">
                <div class="offcanvas__overlay" data-entity="offcanvas-overlay"></div>
                <div class="offcanvas__body" data-entity="offcanvas-body">

                    <div class="offcanvas__header">
                        <div class="offcanvas__title" data-entity="offcanvas-title">Выберите размер</div>
                        <div class="offcanvas__header-actions">
                            <button class="btn btn__icon" data-entity="offcanvas-close" aria-label="Close">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="3.35355" y1="3.14645" x2="20.3536" y2="20.1464" stroke="black"/>
                                    <line x1="3.64645" y1="20.1464" x2="20.6464" y2="3.14645" stroke="black"/>
                                </svg>
                            </button>
                        </div>
                    </div>

                    <div class="offcanvas__content" data-entity="offcanvas-content"></div>
                </div>
            </div>
        `;
    }
}